import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "values", "options", "label", "placeholder", "disabled", "required", "loading", "multiselect"]

import { ref } from 'vue';
import { debounce } from 'lodash';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceDropdown',
  props: {
    value: {},
    values: {},
    options: {},
    disabled: { type: Boolean },
    required: { type: Boolean },
    placeholder: {},
    label: {},
    onDropdownChange: { type: Function },
    fetchAllResources: { type: Function },
    searchResources: { type: Function },
    isLoading: { type: Boolean },
    multiselect: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const debounceTime = ref<number>(1000);

// Monotonic token identifying the most recent resource search/restore. A
// search response only applies if its token is still current, so a request
// that resolves after the user cleared (or started a newer search) is dropped
// instead of overwriting the list. `.cancel()` alone can't do this: it only
// stops a debounced call that hasn't fired yet, not a request already in flight.
let resourceSearchSeq = 0;

async function wrapSearchResources(query: string) {
  const seq = ++resourceSearchSeq;
  if (seq !== resourceSearchSeq) {
      return;
  }

  try {
    await props.searchResources(query);
  } catch {
    console.error('Error searching resources');
  }
}

const debouncedSearchResources = debounce(wrapSearchResources, debounceTime.value);

// Restore the initial resource list when the search is cleared. Bumping the
// token invalidates any search response still in flight; cancelling drops any
// debounced search not yet fired. Both are needed to avoid the cleared list
// being overwritten by a late response.
function restoreResources() {
  resourceSearchSeq++;
  debouncedSearchResources.cancel();
  props.fetchAllResources();
}

// Route filter events: an empty query means the search was cleared.
function onResourceFilter(query: string) {
  if (!query.length) {
    restoreResources();
    return;
  }

  debouncedSearchResources(query);
}

// The dropdown doesn't emit events for two gestures we care about: opening the
// panel (the `trigger`) and clearing the search box (the `search-clear-btn`).
// Without handling them the dropdown keeps showing the last /namespacematches
// subset, so a reopen shows stale results plus the selected item instead of the
// full list.
function onDropdownClick(e: MouseEvent) {
  const { fetchAllResources } = props;
  const restoreOn = ['trigger', 'search-clear-btn'];

  const shouldRestore = e.composedPath().some(
    (el) => el instanceof HTMLElement &&
      restoreOn.some((cls) => el.classList.contains(cls))
  );

  if (shouldRestore) {
    fetchAllResources();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-dropdown", {
    value: _ctx.value,
    values: _ctx.values,
    options: _ctx.options,
    label: _ctx.label,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    "data-testid": "epinio_app-resource-dropdown",
    required: _ctx.required,
    filterable: "",
    loading: _ctx.isLoading,
    multiselect: _ctx.multiselect,
    style: {"width":"100%"},
    onDropdownChange: _cache[0] || (_cache[0] = (e) => _ctx.onDropdownChange(e)),
    onDropdownFilter: _cache[1] || (_cache[1] = (e) => { onResourceFilter(e.detail.filter); }),
    onClick: onDropdownClick
  }, null, 40, _hoisted_1))
}
}

})